import React from 'react';
import { useTranslation } from 'react-i18next';

import { ColorPicker, Section, Icon, InfoText, Button } from '@weezevent/nacre';

import css from '../../templates.module.css';

const ColorSection = ({ form, setForm, colorField, handleReset }) => {
    const { t } = useTranslation();
    const colorValue = form[colorField] ?? '';

    return (
        <Section className={css['brandkit-color-section']}>
            <span className={css['brandkit-color-label']}>
                <ColorPicker
                    key={`${colorField}_picker_${colorValue}`}
                    label={t(`sauron.emails.templates.brandkits.settings.${colorField}`)}
                    onChange={(_, value) => setForm(colorField, value)}
                    value={colorValue}
                />
                <InfoText className={css['color-picker-label']} subtitle={t(`sauron.emails.templates.brandkits.settings.${colorField}_subtitle`)}>
                    {t(`sauron.emails.templates.brandkits.settings.${colorField}`)}
                </InfoText>
            </span>
            {form[colorField] ? (
                <Button basic icon={<Icon name="Reset" />} onClick={() => handleReset(colorField, false, null)}>
                    {t('common.cta.reset')}
                </Button>
            ) : (
                <span className={css['color-picker-default']}>{t('sauron.emails.templates.brandkits.settings.default_color')}</span>
            )}
        </Section>
    );
};

export default ColorSection;
